/**
 * Shared React-Query status derivations used across the Punchup table pages.
 */

/**
 * True for a *background re-fetch* of an already-loaded query — fetching, but neither the initial
 * load nor pagination. This is the single source for "should the table show its dim re-fetch
 * overlay" (`PunchupTableContainer isRefetching`): the initial load shows the centred
 * `PunchupTableLoadingRow` and pagination shows the load-more spinner instead, so both are excluded.
 *
 * Takes the discrete flags (not a whole query object) so it also composes with multi-query pages —
 * e.g. Scanned Tickets merges two queries' `isFetching` and additionally gates on `!autoRefresh`:
 * `isBackgroundRefetch({ isFetching, isLoading }) && !autoRefresh`.
 */
export const isBackgroundRefetch = (q: {
	isFetching?: boolean;
	isLoading?: boolean;
	isFetchingNextPage?: boolean;
}): boolean => !!q.isFetching && !q.isLoading && !q.isFetchingNextPage;
